import { FC, useState } from 'react';

import CKEditor from 'modules/_shared/components/CKEditor';

type SendEmailBodyProps = {
  body: string;
  onChangeBody: (content: string) => void; // eslint-disable-line no-unused-vars
};

const SendEmailBody: FC<SendEmailBodyProps> = ({ body, onChangeBody }) => {
  const [editorInstance, setEditorInstance] = useState<any>(null);

  const handleChangeEditorInstance = (instance: any) => {
    setEditorInstance(instance);
  };

  const handleContentChange = () => {
    if (editorInstance) {
      const newContent = editorInstance.getData();
      if (newContent !== body) {
        onChangeBody(newContent);
      }
    }
  };

  return (
    <div className="nk-reply-form-field p-0 send-email-editor">
      <CKEditor
        documentModel={body || ''}
        documentName="email"
        editorInstance={editorInstance}
        enableMentions={false}
        isCompactVersion
        isEmailVersion
        onChangeContent={handleContentChange}
        setEditorInstance={handleChangeEditorInstance}
      />
    </div>
  );
};

export default SendEmailBody;
